export { default } from './DetailedCarNewMain';
